import React, { useState, useEffect } from "react";

function LoaderGraph(props) {
	const styleObj = { ...props.style, backgroundColor: "#f9f9f9" };
	const [loadingFail, setLoadingFail] = useState(false);
	const styleText = {
		color: "#c1c1c1",
		fontSize: "22px",
	};
	useEffect(() => {
		const timer = setTimeout(() => {
			setLoadingFail(true);
		}, 15000);

		return () => clearTimeout(timer);
	}, []);

	return (
		<div style={styleObj} className="graph-loader">
			{!loadingFail ? (
				<>
					<div></div>
					<div></div>
					<div></div>
				</>
			) : (
				<h1 style={styleText}>Unable to fetch data..</h1>
			)}
		</div>
	);
}

export default LoaderGraph;
